const routes = [
    {
        path: "/cars",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'car_index'
        }
    }
];

export default routes;
